import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ISubscribers {
    subscriber_id: number,
    full_name: string,
    car_number: string,
    phone: string,
    credit: number,
    active: boolean,
    update_subscribe: Date
}

interface ISubscribersData {
    list?: Array<ISubscribers>;
    pageNo: number;
    pageSize: number;
    searchKey?: string;
    totalCount?: number;
    message?: string;
}

const initialState: ISubscribersData = {
    pageNo: 1,
    pageSize: 20,
    searchKey: '',
    list: [],
    totalCount: 0,
    message: '',
};

const SubscribersSlice = createSlice({
    name: "Subscribers",
    initialState,
    reducers: {
        setSubscribersList: (state, _action: PayloadAction<ISubscribersData>) => {
            state.list = _action.payload.list;
            state.pageNo = _action.payload.pageNo;
            state.pageSize = _action.payload.pageSize;
            state.totalCount = _action.payload.totalCount;
        },
        resetSubscribersToInit: (state) => {
            state = initialState;
        },
        setSubscribersMessage: (state, _action: PayloadAction<string>) => {
            state.message = _action.payload;
        },
    },
});

export const { setSubscribersList, resetSubscribersToInit, setSubscribersMessage } = SubscribersSlice.actions;

export default SubscribersSlice.reducer;

